module.exports = __webpack_public_path__ + "media/assets/images/comgy-logo-18699b481dfe1815c71e53a1222015c4.svg";